// assets
import {
    AppstoreAddOutlined,
    AntDesignOutlined,
    BarcodeOutlined,
    BgColorsOutlined,
    FontSizeOutlined,
    LoadingOutlined,
    ChromeOutlined,
} from '@ant-design/icons';
import { NavGroupType } from './types';

// icons
const icons = {
    FontSizeOutlined,
    BgColorsOutlined,
    BarcodeOutlined,
    AntDesignOutlined,
    LoadingOutlined,
    AppstoreAddOutlined,
    ChromeOutlined,
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const utilities: NavGroupType = {
    id: 'utilities',
    title: 'Templates (only dev)',
    type: 'group',
    children: {
        typography: {
            id: 'util-typography',
            title: 'Typography',
            type: 'item',
            url: '/templates/typography',
            icon: icons.FontSizeOutlined,
        },
        color: {
            id: 'util-color',
            title: 'Color',
            type: 'item',
            url: '/templates/color',
            icon: icons.BgColorsOutlined,
        },
        shadow: {
            id: 'util-shadow',
            title: 'Shadow',
            type: 'item',
            url: '/templates/shadow',
            icon: icons.BarcodeOutlined,
        },
        icons: {
            id: 'ant-icons',
            title: 'Ant Icons',
            type: 'item',
            url: '/templates/icons/ant',
            icon: icons.AntDesignOutlined,
            breadcrumbs: false,
        },
        samplePage: {
            id: 'sample-page',
            title: 'Sample Page',
            type: 'item',
            url: '/templates/sample-page',
            icon: icons.ChromeOutlined,
        },
    },
};

export default utilities;
